const toCamelKey = (s: string) => s.charAt(0).toLowerCase() + s.slice(1)

export const transformKeys = (obj: any): any => {
  if (Array.isArray(obj)) return obj.map(transformKeys)
  if (obj !== null && typeof obj === 'object')
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [toCamelKey(k), transformKeys(v)])
    )
  return obj
}
